import type { TypographyVariantProps } from "../../atoms/typography";
import type { ChatBubbleVariant } from "./types";

type TypographyColor = NonNullable<TypographyVariantProps["color"]>;

/** Typography colour token for `ChatBubble.Author` per variant. */
export const chatBubbleAuthorColor: Record<ChatBubbleVariant, TypographyColor> = {
  sender: "brand-on-primary",
  receiver: "neutral-foreground-intermediate",
  system: "neutral-foreground-attenuated",
};

/** Typography colour token for `ChatBubble.Content` per variant. */
export const chatBubbleContentColor: Record<ChatBubbleVariant, TypographyColor> = {
  sender: "brand-on-primary",
  receiver: "neutral-foreground-default",
  system: "neutral-foreground-attenuated",
};

/** Typography colour token for `ChatBubble.Timestamp` per variant. */
export const chatBubbleTimestampColor: Record<ChatBubbleVariant, TypographyColor> = {
  sender: "brand-on-static-attenuated",
  receiver: "neutral-foreground-attenuated",
  system: "neutral-foreground-attenuated",
};
